import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingPremiumBuilderInfo } from 'shared/containers/AuthorAsideContainerNew/parts';
import { isCommercialSelector } from 'shared/selectors/offerData/offer/isCommercialSelector';

import { AsideGroup } from '../../components/AsideSection/AsideGroup';
import { AsideItem } from '../../components/AsideSection/AsideItem';
import { AsideSection } from '../../components/AsideSection/AsideSection';
import { DealRent } from '../../components/DealRent';
import { PriceAuction } from '../../components/PriceAuction/PriceAuction';
import { OfferCardAsideContainer } from '../../components/aside/container';
import { AsideBannersContainer } from '../../components/aside_banners/container';
import { isDealRent as isDealRentSelector } from '../../selectors/isDealRent';
import { selectIsMortgageBannerEnabled } from '../../selectors/mortgage/selectIsMortgageBannerEnabled';
import { selectIsNewbuildingPremiumRate } from '../../selectors/newbuildingPremiumRate';
import { selectIsMortgageBannerAvailable } from '../../selectors/offerData/selectIsMortgageBannerAvailable';
import { selectIsAuctionBankObject } from '../../selectors/selectIsAuctionBankObject';
import { AsideMortgageBannerContainer } from '../Adfox/AsideMortgageBannerContainer';
import { useApplicationContext } from '../ApplicationContext';
import { AsideContactsContainer } from '../AsideContacts/AsideContacts';
import { AuthorAsideContainer as AuthorAsideContainerNew } from '../AuthorAsideContainerNew';
import { MortgageSidebarBannerContainer } from '../MortgageSidebarBannerContainer';
import { MortgageWidgetContainer } from '../MortgageWidgetRedesignContainer';
import { NewbuildingBuildersFactsContainer } from '../NewbuildingBuildersFactsContainer';
import { OfferFactsInSidebarContainer } from '../OfferFactsInSidebarContainer';
import { PriceRelevance } from '../PriceRelevance';
import { RentBlockContainer } from '../RentBlockContainer';
import { AgencyBrandingAsideCardContainer } from '../agencyBranding/AgencyBrandingAsideCard';
import { PriceContainer } from './Price';
import { PriceChangesContainer } from './PriceChanges';

export const AsideRedesignedContainer = () => {
  const { logger } = useApplicationContext();
  const isDealRent = useSelector(isDealRentSelector);

  const isAuctionBankObject = useSelector(selectIsAuctionBankObject);
  const isCommercial = useSelector(isCommercialSelector);
  const isPremiumNewbuilding = useSelector(selectIsNewbuildingPremiumRate);
  const isMortgageEnabled = useSelector(selectIsMortgageBannerEnabled);
  const isBannerVisible = useSelector(selectIsMortgageBannerAvailable);

  return (
    <OfferCardAsideContainer>
      <AsideSection>
        <AsideGroup>
          <AsideItem>
            <PriceRelevance />
          </AsideItem>
          <AsideItem>{isAuctionBankObject && <PriceAuction />}</AsideItem>
          <AsideItem>
            <PriceContainer />
          </AsideItem>
          <AsideItem>
            <PriceChangesContainer />
          </AsideItem>
        </AsideGroup>
        <AsideGroup>
          <AsideItem>{isMortgageEnabled && <MortgageWidgetContainer />}</AsideItem>
        </AsideGroup>
        <AsideGroup>
          <AsideItem>
            <OfferFactsInSidebarContainer />
          </AsideItem>
        </AsideGroup>
        <AsideContactsContainer />
      </AsideSection>

      <AsideSection>
        <AuthorAsideContainerNew />
      </AsideSection>
      <NewbuildingPremiumBuilderInfo />
      <AgencyBrandingAsideCardContainer />

      {isBannerVisible && <AsideMortgageBannerContainer />}
      <DealRent />
      {isDealRent && <RentBlockContainer />}
      <NewbuildingBuildersFactsContainer />

      {!isPremiumNewbuilding && (
        <AsideSection withShadow={false} withBorders={false} withSpaces={false}>
          <ErrorLogComponent logger={logger}>
            <AsideBannersContainer />
          </ErrorLogComponent>
        </AsideSection>
      )}
      {!isPremiumNewbuilding && !isCommercial && (
        <AsideSection withShadow={false}>
          <MortgageSidebarBannerContainer />
        </AsideSection>
      )}
    </OfferCardAsideContainer>
  );
};
